var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export var injectStringMethodsNoops = function (element, defaultText) {
    if (typeof element === 'string') {
        return element;
    }
    // noop for string methods
    var noopReturnValue = '';
    var noop = function () { return noopReturnValue; };
    var elementWithNoops = __assign(__assign({}, element), { replace: noop, replaceAll: noop, split: function () { return [elementWithNoops]; }, slice: noop, substring: noop, substr: noop, toUpperCase: noop, toLowerCase: noop, toLocaleLowerCase: noop, toLocaleUpperCase: noop, concat: noop, trim: noop, trimStart: noop, trimEnd: noop, charAt: function () { return ''; }, toJSON: function () { return defaultText; }, indexOf: function () { return -1; }, matchAll: function () { return ''.matchAll(/a/g); }, match: function () { return null; } });
    noopReturnValue = elementWithNoops;
    // Prevent infinite recursion
    Object.defineProperty(elementWithNoops, '_owner', {
        value: elementWithNoops._owner,
        enumerable: false,
    });
    return elementWithNoops;
};
var I18NEXT_NATIVE_PARAMS = new Set([
    'defaultValue',
    'count',
    'context',
    'replace',
    'lng',
    'lngs',
    'fallbackLng',
    'ns',
    'keySeparator',
    'nsSeparator',
    'returnObjects',
    'returnDetails',
    'joinArrays',
    'postProcess',
    'interpolation',
]);
var SEPARATOR = '__i18nspect__';
/**
 * Replace i18next params that are React elements to be string, so that it does not become [object Object] when passed to i18n.t function
 * e.g.
 * i18n.t('some_keys', { n: <DateWrapper /> })
 *
 * Before
 * {
 *   n: <DateWrapper />,
 *   value: 'a',
 * }
 *
 * After
 * {
 *   n: '__i18nspect__(((n)))__i18nspect__',   // Replaced the React element with a string
 *   value: 'a',
 * }
 *
 * We will later manually replace them with actual React elements
 */
export var filterReactElementParams = function (_a) {
    var params = _a.params, elementTypes = _a.elementTypes;
    var reactElementParams = {};
    var filteredParams = Object.keys(params).reduce(function (acc, key) {
        var param = params[key];
        if (!I18NEXT_NATIVE_PARAMS.has(key) && // not a i18next native param
            React.isValidElement(param) &&
            typeof param.type === 'function' &&
            // @ts-expect-error function name
            elementTypes.some(function (el) { var _a; return ((_a = param.type) === null || _a === void 0 ? void 0 : _a.name) === el; })) {
            var reactElementKey = "(((".concat(key, ")))");
            reactElementParams[reactElementKey] = param;
            acc[key] = "".concat(SEPARATOR).concat(reactElementKey).concat(SEPARATOR);
        }
        else {
            acc[key] = param;
        }
        return acc;
    }, {});
    return {
        filteredParams: filteredParams,
        reactElementParams: reactElementParams,
    };
};
/**
 * Substitute text with react elements
 * Params:
 * {
 *   text: 'Starting from __i18nspect__(((before)))__i18nspect__ until __i18nspect__(((after)))__i18nspect__';
 *   reactElementsParams: {
 *     '(((before)))': <DateWrapper ... />,
 *     '(((after)))': <DateWrapper ... />
 *   }
 * }
 *
 * Output:
 * <>
 *   [
 *     'Starting from ',
 *     <DateWrapper .../>,
 *     'until ',
 *     <DateWrapper .../>'
 *   ]
 * </>
 */
export var restoreTextReactElements = function (_a) {
    var text = _a.text, reactElementParams = _a.reactElementParams;
    var splitted = text.split(SEPARATOR);
    if (splitted.length === 1)
        return text;
    var mapped = splitted.map(function (val, index) {
        if (reactElementParams[val])
            return React.cloneElement(reactElementParams[val], {
                key: "".concat(index, "-").concat(val),
            });
        return _jsx(React.Fragment, { children: val }, "".concat(index, "-").concat(val));
    });
    return _jsx(_Fragment, { children: mapped });
};
